import React, { FC } from "react";
import { useSelector } from "react-redux";

import {
  CancelInvoiceAction,
  CopyInvoiceLinkAction,
  DeleteInvoiceAction,
  DownloadInvoiceAction,
  DuplicateInvoiceAction,
} from "../../actions";
import { selectInvoice } from "../../../store/reducers/invoice";
import { InvoiceStatus } from "../../../types/InvoiceTypes";

type Props = {
  publicView?: boolean;
  onDelete?: () => void;
  tooltip?: boolean;
};

export const InvoiceHeaderToolbar: FC<Props> = ({
  publicView,
  onDelete,
  tooltip = false,
}) => {
  const invoice = useSelector(selectInvoice);

  if (!invoice) {
    return <></>;
  }

  const showDeleteAction = invoice.status === InvoiceStatus.DRAFT;
  const showCancelAction = invoice.status === InvoiceStatus.PENDING;
  const showDuplicateAction = invoice.user_is_creator;

  return (
    <div className="flex gap-6">
      <DownloadInvoiceAction invoice={invoice} />

      <CopyInvoiceLinkAction
        invoicePublicId={invoice?.public_id}
        tooltip={tooltip}
      />

      {!publicView && showDuplicateAction && (
        <DuplicateInvoiceAction invoiceId={invoice.id} tooltip={tooltip} />
      )}

      {!publicView && showDeleteAction && (
        <DeleteInvoiceAction invoiceId={invoice.id} onDelete={onDelete} />
      )}

      {!publicView && showCancelAction && (
        <CancelInvoiceAction invoiceId={invoice.id} />
      )}
    </div>
  );
};
